import Button from 'react-bootstrap/Button'
import Offcanvas from 'react-bootstrap/Offcanvas'

import { SUPPORT_PANEL_ID } from './constants'
import { useSupport } from './SupportProvider'
import SupportIframe from './SupportIframe'
import { getSupportPortalUrl, openSupportPortal } from './supportWidgetUtils'

export default function SupportPanel() {
  const { isOpen, hasOpened, close } = useSupport()
  const portalUrl = getSupportPortalUrl()

  return (
    <Offcanvas
      id={SUPPORT_PANEL_ID}
      show={isOpen}
      onHide={close}
      placement="end"
      restoreFocus
      enforceFocus
      keyboard
      scroll={false}
      aria-labelledby="support-widget-title"
      className="support-widget__drawer"
      data-testid="support-widget-panel"
    >
      <Offcanvas.Header className="support-widget__header">
        <div className="support-widget__brand">
          <Offcanvas.Title as="h2" id="support-widget-title">
            Need Help?
          </Offcanvas.Title>
          <p className="support-widget__subtitle">
            Blocktickets IT Support — all request types
          </p>
        </div>
        <Button
          type="button"
          variant="outline-light"
          size="sm"
          className="support-widget__external"
          data-testid="support-widget-open-external"
          onClick={() => openSupportPortal(portalUrl)}
        >
          Open in new tab
        </Button>
        <button
          type="button"
          className="btn-close"
          aria-label="Close support panel"
          data-testid="support-widget-close"
          onClick={close}
        />
      </Offcanvas.Header>
      <Offcanvas.Body className="support-widget__body">
        {hasOpened ? <SupportIframe src={portalUrl} /> : null}
      </Offcanvas.Body>
    </Offcanvas>
  )
}
